import { createContext, useContext } from "react";

import type { Me } from "@/api/types";

export const AuthContext = createContext<Me | null>(null);

export function useAuth(): Me {
  const me = useContext(AuthContext);
  if (!me) throw new Error("useAuth must be used inside an authenticated route");
  return me;
}
